import type { TeoHelpTopic } from '../../../../teoCore/TeoHelp';
import { useTeoCore } from '../../../utils/teo-context';

class HelpData {
  #helpData = $state<{ current: Promise<TeoHelpTopic> | null }>({ current: null });

  get current() {
    return this.#helpData.current;
  }

  set current(data: Promise<TeoHelpTopic> | null) {
    this.#helpData.current = data;
  }
}

export function useHelp() {
  const core = useTeoCore();
  const helpData = new HelpData();
  if (!core) return helpData;
  $effect(() => {
    return core.help.addEventListener('helpChanged', (data) => {
      helpData.current = data;
    });
  });
  return helpData;
}
